import useApi from '../hook/useApi';

const useSuggestionsApi = () => {
  const { sendRequest, loading, data, error } = useApi();


  const getSuggestionsData = async (page = 1, search = '', status = "") => {
    return sendRequest(`/imp/suggestion_screen/get_all_suggestion_list?page=${page}&search=${search}&status=${status}`, 'GET', {});
  };


  const approveRejectSuggestion = async (id, payload) => {
    return sendRequest(`/imp/suggestion_screen/edit_suggestion/${id}`, 'PUT', payload);
  };


  return {
    getSuggestionsData,
    approveRejectSuggestion,
    loading,
    data,
    error,
  };
};

export default useSuggestionsApi;